import React from 'react';

const LoadingSpinner = ({ 
  size = 'md', 
  text = '', 
  className = '',
  color = 'primary' 
}) => {
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
    xl: 'w-16 h-16'
  };

  const colors = {
    primary: 'border-border-primary border-t-navigation',
    accent: 'border-border-primary border-t-accent',
    success: 'border-border-primary border-t-success',
    error: 'border-border-primary border-t-error'
  };

  const textSizes = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
    xl: 'text-lg'
  };

  return (
    <div className={`flex flex-col items-center justify-center space-y-3 ${className}`}>
      {/* Spinner */}
      <div 
        className={`
          ${sizes[size]} 
          border-2 
          ${colors[color]} 
          rounded-full 
          animate-spin
        `}
      />
      
      {/* Text */}
      {text && (
        <p className={`text-text-secondary ${textSizes[size]} font-medium`}>
          {text}
        </p>
      )}
    </div>
  );
};

// Loading overlay component
const LoadingOverlay = ({ isLoading, text = 'Loading...', children }) => {
  if (!isLoading) {
    return children;
  }

  return (
    <div className="relative">
      {/* Content with overlay */}
      <div className="opacity-50 pointer-events-none">
        {children}
      </div>
      
      {/* Loading overlay */}
      <div className="absolute inset-0 bg-surface-elevated/80 backdrop-blur-sm flex items-center justify-center rounded-xl">
        <LoadingSpinner size="lg" text={text} />
      </div>
    </div>
  );
};

// Loading page component
const LoadingPage = ({ text = 'Loading...' }) => {
  return (
    <div className="min-h-screen bg-bg-secondary flex items-center justify-center">
      <div className="card p-12">
        <LoadingSpinner size="xl" text={text} />
      </div>
    </div>
  );
};

// Loading card component
const LoadingCard = ({ text = 'Loading...', className = '' }) => {
  return (
    <div className={`card p-8 ${className}`}>
      <LoadingSpinner size="lg" text={text} />
    </div>
  );
};

export default LoadingSpinner;
export { LoadingOverlay, LoadingPage, LoadingCard };